module.exports = __webpack_public_path__ + "static/media/(000240).aa6957ff.jpg";